export const GA_EVENTS = {
	ACTION: {
		LOGIN_PAGE_LOADED: "demand_dashboard_login_page_loaded",
		LOGIN: "demand_dashboard_login",
		LOGOUT: "demand_dashboard_logout",
		PAGE_LOAD: "demand_dashboard_loaded",
		LINK_SHARED: "demand_dashboard_link_shared",
		LEAD_ADDED: "demand_dashboard_lead_added",
		INTEGRATIONS: "demand_dashboard_integrations",
		ADD_SUB_PARTNER: "demand_dashboard_add_subpartner",
		UPDATE_SUB_PARTNER: "demand_dashboard_update_subpartner",
		REMOVE_SUB_PARTNER: "demand_dashboard_remove_subpartner",
		REACTIVATE_SUB_PARTNER: "demand_dashboard_reactivate_subpartner",
		REACTIVATE_USER: "demand_dashboard_reactivate_user",
		ADD_TEAM_USER: "demand_dashboard_add_user",
		REMOVE_TEAM_USER: "demand_dashboard_remove_user",
		SUPPORT_CLICK: "demand_dashboard_support_click",
		CTA_CLICK: "demand_dashboard_cta_click",
		MOBILE_WAITLIST_JOIN: "flex_mobile_waitlist_join",
		MOBILE_WAITLIST_DISMISS: "flex_mobile_waitlist_dismiss",
		MOBILE_WAITLIST_CLOSE: "flex_mobile_waitlist_close",
		MOBILE_WAITLIST_SHOWN: "flex_mobile_waitlist_shown",
	},
	LABEL: {
		DASHBOARD: "dashboard",
		LEADS: "leads",
		PROFILE: "profile",
		SUB_PARTNERS: "subPartners",
		SUPPORT: "support",
		TEAMS: "teams",
		INTEGRATIONS: "integrations",
		COMMISSIONS: "commissions",
		MOBILE_WAITLIST: "mobile_waitlist",
	},
	CATEGORY: "demand_dashboard",
} as const;
